import type { WorksheetRules } from '../as400CellRuleKinds';

/**
 * The Price worksheet's own rules, on top of its columns' character limits and
 * number formats (the PCPRC prices take two decimals, declared on the
 * contract columns). Append new entries; keep one ticket's entries together
 * under its comment.
 */
export const PRICE_SHEET_RULES: WorksheetRules = {
  rules: [],
  autoFills: [],
  addDefaults: [],
};
